import store from '@/store';
import { findModule } from '@/stores/appModule';

export const setModule = function set(name) {
  const module = findModule(name);
  store.dispatch('appModules/SETMODULE', module);
};

function ensureArray(prop) {
  return (Array.isArray(prop)) ? prop : Array.of(prop);
}

export default [
  {
    path: '/locationId',
    name: 'locationID',
    redirect: { name: 'groupList' },
    component: () => import(/* webpackChunkName: "locationid" */ '@/views/LocationId/LocationIdRouterView.vue'),
    beforeEnter(to, from, next) {
      if (!store.getters.permissions.includes('LOCID:APP:NAV:VIEW')) {
        next({
          name: 'notAuthorized',
        });
      } else {
        setModule('locationID');
        if (to.meta.permission && !store.getters.permissions.includes(to.meta.permission)) {
          next({
            name: 'notAuthorized',
          });
        }
        next();
      }
    },
    children: [
      {
        path: 'location-groups',
        name: 'groupList',
        meta: { title: 'Location ID: Dashboard' },
        props: true,
        component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupList.vue'),
      },
      {
        path: 'location-groups/:groupId/duplicate',
        name: 'duplicateGroup',
        component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupDuplicate.vue'),
        props: true,
        meta: { permission: 'LOCID:LOC:GROUP', title: 'Location ID: Duplicate Group' },
      },
      {
        path: 'location-groups/:groupId',
        name: 'profilegroup',
        component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupProfileView.vue'),
        props: true,
        meta: { permission: 'LOCID:LOC:GROUP', title: 'Location ID: Group Profile' },
        children: [
          {
            path: 'details',
            name: 'groupProfileDetails',
            component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupProfileDetails.vue'),
            props: true,
            meta: { permission: 'LOCID:LOC:GROUP', title: 'Location ID: Group Profile - Details' },
          },
          {
            path: 'locationlist/:locationId?',
            name: 'groupLocationList',
            component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupProfileLocationList.vue'),
            props: (route) => {
              const {
                childLevel,
                parentId,
                sortField,
                sortOrder,
                page,
              } = route.query;
              const {
                groupId,
              } = route.params;
              return {
                groupId,
                childLevel,
                parentId,
                sortField,
                sortOrder,
                page,
              };
            },
            meta: { permission: 'LOCID:LOC:GROUP', title: 'Location ID: Group Profile - Location List' },
          },
        ],
      },
      {
        path: 'addgroup',
        name: 'addgroup',
        component: () => import(/* webpackChunkName: "groups" */ '@/views/LocationId/Groups/GroupAdd.vue'),
        props: true,
        meta: { permission: 'LOCID:LOC:GROUP ', title: 'Location ID: Add a Location Group' },
      },
      {
        path: 'locations/:id',
        component: () => import(/* webpackChunkName: "locations" */ '@/views/LocationId/Locations/LocationProfile.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'locationDetails',
            meta: { title: 'Location ID: Location Profile - Details' },
            component: () => import(/* webpackChunkName: "locations" */ '@/views/LocationId/Locations/LocationProfileDetails.vue'),
            props: true,
          },
          {
            path: 'history',
            name: 'locationHistory',
            meta: { title: 'Location ID: Location Profile - History' },
            component: () => import(/* webpackChunkName: "locations" */ '@/views/LocationId/Locations/LocationProfileHistory.vue'),
            props: true,
          },
          {
            path: '/',
            redirect: 'details',
            props: true,
          },
        ],
      },
      {
        path: 'search',
        name: 'search',
        meta: { permission: 'LOCID:SRCH:OPTIONS:VIEW', title: 'Location ID: Search Options' },
        component: () => import(/* webpackChunkName: "search" */ '@/views/LocationId/Search/Search.vue'),
        children: [
          {
            path: '',
            redirect: 'locationsearch',
          },
          {
            path: 'locationsearch',
            name: 'locationSearch',
            meta: { permission: 'LOCID:SRCH:OPTIONS:VIEW', title: 'Location ID: Search Options - Location Search' },
            component: () => import(/* webpackChunkName: "search" */ '@/views/LocationId/Search/LocationSearch.vue'),
          },
          {
            path: 'idsearch',
            name: 'idSearch',
            meta: { permission: 'LOCID:SRCH:OPTIONS:VIEW', title: 'Location ID: Search Options - ID Search' },
            component: () => import(/* webpackChunkName: "search" */ '@/views/LocationId/Search/IdSearch.vue'),
          },
          {
            path: 'advancedsearch',
            name: 'advancedSearch',
            meta: { permission: 'LOCID:SRCH:OPTIONS:VIEW', title: 'Location ID: Search Options - Advanced Search' },
            component: () => import(/* webpackChunkName: "search" */ '@/views/LocationId/Search/AdvancedSearch.vue'),
          },
        ],
      },
      {
        path: 'searchresults',
        name: 'searchresults',
        component: () => import(/* webpackChunkName: "search" */ '@/views/LocationId/Search/SearchResults.vue'),
        meta: { permission: 'LOCID:SRCH:OPTIONS:VIEW' },
      },
      {
        path: 'reports',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportsMyActivity.vue'),
        children: [
          {
            // UserProfile will be rendered inside User's <router-view>
            // when /user/:id/profile is matched
            path: '',
            name: 'reportsmainl',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/Reports.vue'),
            meta: { permission: 'LOCID:REP:VIEW', title: 'Location ID: Reports' },
          },
        ],
      },
      {
        path: 'reportdescriptions',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportDescriptions.vue'),
        children: [
          {
            path: 'customizelocationreport',
            name: 'customizelocationreport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/LocReport.vue'),
            meta: { permission: 'LOCID:REP:LOCATIONS', title: 'Location ID: All Locations Report' },
          },
          {
            path: 'customizelocalcodereport',
            name: 'customizelocalcodereport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/LocalcodeReport.vue'),
            meta: { permission: 'LOCID:REP:LOCALCODES', title: 'Location ID: Distinct Local Code Report' },
          },
          {
            path: 'customizelocationbygroupreport',
            name: 'customizelocationbygroupreport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/LocByGroupReport.vue'),
            meta: { permission: 'LOCID:REP:LOCBYGROUP', title: 'Location ID: Location by Group with Hierarchy Report' },
          },
        ],
      },
      {
        path: 'addOption',
        name: 'LIAddUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/AddUser.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:ADD', title: 'Security Manager: Add Options' },
      },
      {
        path: 'ruleManager',
        name: 'LidRuleManager',
        meta: { permission: 'SYS:SYS:RULEMGR:VIEW' },
        redirect: { name: 'LidRuleManagerPersonId' },
        component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerHeader.vue'),
        props: true,
        children: [
          {
            path: 'personId',
            name: 'LidRuleManagerPersonId',
            meta: { title: 'Rule Manager: Person ID' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerPersonId.vue'),
            props: true,
          },
          {
            path: 'directMatch',
            name: 'LidRuleManagerDirectMatch',
            meta: { title: 'Rule Manager: Directmatch' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerDirectMatch.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'securityManager',
        name: 'LISecurityManager',
        meta: { title: 'Security Manager' },
        component: () => import(/* webpackChunkName: "securityManager" */ '@/views/SecurityManager/SecurityManager.vue'),
        props: (route) => {
          const {
            sortField,
            sortOrder,
            page,
            search,
            isActive,
            role = [],
            districtCode = [],
            schoolCode = [],
            group = [],
            status = [],
          } = route.query;

          return {
            sortField,
            sortOrder,
            page,
            search,
            isActive: Boolean(isActive),
            roleCodes: ensureArray(role),
            districtCodes: ensureArray(districtCode),
            schoolCodes: ensureArray(schoolCode),
            groupCodes: ensureArray(group),
            statuses: ensureArray(status),
          };
        },
      },
      {
        path: 'user/:id',
        name: 'LIUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/UserProfile.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:VIEW', title: 'Security Manager: User Profile' },
      },
      {
        path: 'location-create',
        name: 'locationCreate',
        component: () => import(/* webpackChunkName: "location-create" */ '@/views/LocationId/LocationCreate/AddLocation.vue'),
        meta: { permission: 'LOCID:LOC:ADD', title: 'Location ID: Create a Location' },
      },
      {
        path: 'near-matches/:nearMatchId?',
        name: 'nearMatches',
        component: () => import(/* webpackChunkName: "location-create" */ '@/views/LocationId/LocationCreate/NearMatches.vue'),
        props: true,
        meta: { permission: 'LOCID:MATCH:RESOLVENM:VIEW', title: 'Location ID: Near Match List' },
      },
      {
        path: 'compare/:nearMatchId',
        name: 'compareMatches',
        component: () => import(/* webpackChunkName: "location-create" */ '@/views/LocationId/LocationCreate/CompareMatches.vue'),
        props: true,
        meta: { permission: 'LOCID:MATCH:RESOLVENM:VIEW', title: 'Location ID: Near Match Compare' },
      },
      {
        path: 'roles/:roleId',
        name: 'securityManagerHeader',
        component: () => import(/* webpackChunkName: "securtiyManager" */ '@/components/SecurityManagerHeader.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager' },
        children: [
          {
            path: 'details',
            name: 'securityManagerDetails',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerDetails.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Details' },
          },
          {
            path: 'privileges',
            name: 'securityManagerPrivilege',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerPrivilege.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Privileges' },
          },
        ],
      },
      {
        path: 'configurationManager',
        name: 'LIConfigurationManager',
        redirect: { name: 'LISystemConfiguration' },
        component: () => import(/* webpackChunkName: "configurationManager" */ '@/views/Configuration/ConfigurationManagerRouterView.vue'),
        meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW' },
        beforeEnter(to, from, next) {
          if (to.name === 'LIConfigurationManager') {
            const routes = [
              {
                name: 'LISystemConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:VIEW',
              },
              {
                name: 'LIPersonIdConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB',
              },
              {
                name: 'LIDirectMatchConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB',
              },
              {
                name: 'LIDataMartsConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB',
              },
              {
                name: 'LIScheduleConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB',
              },
              {
                name: 'LIIntegrationConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'LINotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'system',
            name: 'LISystemConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW', title: 'Configuration Manager: System' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "systemConfiguration" */ '@/views/Configuration/ConfigurationSystemRouterView.vue'),
            },
          },
          {
            path: 'personId',
            name: 'LIPersonIdConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB', title: 'Configuration Manager: Person ID' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "personIdConfiguration" */ '@/views/Configuration/ConfigurationPersonIdRouterView.vue'),
            },
          },
          {
            path: 'directmatch',
            name: 'LIDirectMatchConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB', title: 'Configuration Manager: DirectMatch' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "directMatchConfiguration" */ '@/views/Configuration/ConfigurationDirectMatchRouterView.vue'),
            },
          },
          {
            path: 'datamarts',
            name: 'LIDataMartsConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB', title: 'Configuration Manager: Data Marts' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "datamartsConfiguration" */ '@/views/Configuration/ConfigurationDataMartsRouterView.vue'),
            },
          },
          {
            path: 'schedule',
            name: 'LIScheduleConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB', title: 'Configuration Manager: Schedule' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "scheduleConfiguration" */ '@/views/Configuration/ConfigurationScheduleRouterView.vue'),
            },
          },
          {
            path: 'integration',
            name: 'LIIntegrationConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB', title: 'Configuration Manager: Integration' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "integrationConfiguration" */ '@/views/Configuration/ConfigurationIntegrationRouterView.vue'),
            },
          },
        ],
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue'),
      },
    ],
  },
];
